import { render, staticRenderFns } from "./JinghuaList.vue?vue&type=template&id=43e8d4b5&scoped=true"
import script from "./JinghuaList.vue?vue&type=script&lang=ts"
export * from "./JinghuaList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./JinghuaList.vue?vue&type=style&index=0&id=43e8d4b5&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "43e8d4b5",
  "6db61f0d"
  
)

export default component.exports